<template>
  <div class="filtro-rapido-chips">
    <button
      v-for="chip in chips"
      :key="chip.label"
      type="button"
      class="filtro-rapido-chips__chip"
      :class="{ 'is-selected': chip.value === value }"
      :disabled="disabled"
      @click="$emit('input', chip.value)"
    >
      {{ chip.label }}
    </button>
  </div>
</template>

<script>
import { CHIPS_BY_PERSONA } from '@/utils/licitacoesBuckets';

export default {
  name: 'FiltroRapidoChips',
  props: {
    persona: { type: String, default: 'visitante' },
    // Sem default: "undefined" (nenhum chip bate) precisa chegar como undefined, não null
    // ("null" é o value do chip "Todas" — um default aqui mascararia esse estado).
    value: {},
    disabled: { type: Boolean, default: false },
  },
  computed: {
    chips() {
      return CHIPS_BY_PERSONA[this.persona] || CHIPS_BY_PERSONA.visitante;
    },
  },
};
</script>

<style lang="scss" scoped>
// Mesmo valor de $primary em App.vue — sem partial de variáveis compartilhado entre SFCs.
$primary: #2153b5;

.filtro-rapido-chips {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.filtro-rapido-chips__chip {
  background: #f5f5f5;
  border: 1px solid #dbdbdb;
  border-radius: 999px;
  color: #363636;
  cursor: pointer;
  font-size: 0.8125rem;
  line-height: 1.2;
  padding: 0.2rem 0.65rem;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    background: #eeeeee;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;

    &:hover {
      background: #f5f5f5;
    }
  }

  &.is-selected {
    background: $primary;
    border-color: $primary;
    color: #fff;

    &:hover {
      background: darken($primary, 8%);
      border-color: darken($primary, 8%);
    }
  }
}
</style>
